const Resources = {

    table_headers: [
        { 
            text:     '#',
            align:    '',
            value:    ''
        },
        {
            text:   'Question',
            value:  'question'
        },
        {
            text:   'Question Type',
            value:  'question_type'
        },
        {
            text:   'Response Type',
            value:  'response_type'
        },
        // {
        //     text:   'Answer #1',
        //     value:  'answer_1',
        // },
        // {
        //     text:   'Answer #2',
        //     value:  'answer_2',
        // },
        // {
        //     text:   'Answer #3',
        //     value:  'answer_3',
        // },
        // {
        //     text:   'Answer #4',
        //     value:  'answer_4',
        // },
        // {
        //     text:   'Answer #5',
        //     value:  'answer_5',
        // },
        {
            text:   'Status',
            value:  '',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Surveys',
            href:   '/qc-surveys',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

    question_types: [
        {
            id:     1,
            name:   'Equipment/Appearance'
        },
        {
            id:     2,
            name:   'Management Professionalism/Response'
        },
        {
            id:     3,
            name:   'Staff Professionalism/Appearance'
        },
        {
            id:     4,
            name:   'Supplies'
        },
        {
            id:     5,
            name:   'Work Quality'
        },
    ],

    response_types: [
        {
            id:     1,
            name:   'Multiple choice'
        },
        {
            id:     2,
            name:   'Yes/No'
        },
        {
            id:     3,
            name:   'Free comment'
        },
    ],

}

export default Resources;